var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M14.02 6.243L6.244 14.02a2 2 0 0 1 0 2.828l-1.415 1.414a2 2 0 0 1-2.828 0L.586 16.85a2 2 0 0 1 0-2.828L2 12.607a2 2 0 0 1 2.828 0l7.779-7.779a2 2 0 0 1 0-2.828L14.02.586a2 2 0 0 1 2.828 0L18.263 2a2 2 0 0 1 0 2.828L16.85 6.243a2 2 0 0 1-2.828 0zM15.436 2l-1.414 1.414 1.414 1.414 1.414-1.414L15.435 2zM3.415 14.02L2 15.436l1.414 1.414 1.414-1.414-1.414-1.414z", id: "svg1471674153a" })
    ),
    React.createElement(
      "g",
      { transform: "translate(.5 .5)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "svg1471674153b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#svg1471674153a" })
      ),
      React.createElement("use", { fillRule: "nonzero", xlinkHref: "#svg1471674153a" }),
      React.createElement(
        "g",
        { mask: "url(#svg1471674153b)", fill: "currentColor" },
        React.createElement("path", { d: "M0 0h20v20H0z" })
      )
    )
  );
});